import { useEffect, useState } from 'react';

type BusEventCallback<T> = (payload: T | undefined) => void;

type SubscriptionHandle<T> = {
  topicName: string;
  cb: (payload: T | undefined) => void;
};

export interface SgWidgetsBus {
  dangerouslyGetCurrentValue<T>(topicName: string): T | undefined;
  publish<T>(topic: string, value: T | null | undefined): void;
  subscribe<T>(topicName: string, cb: BusEventCallback<T>): SubscriptionHandle<T>;
  unsubscribe<T>(handle: SubscriptionHandle<T>): void;
}

export function getWidgetBus(): SgWidgetsBus | never {
  const widgetConfiguration = window.SGWTWidgetConfiguration;
  if (!widgetConfiguration || !widgetConfiguration.bus) {
    throw new Error('No Widgets bus found');
  }
  return widgetConfiguration.bus as SgWidgetsBus;
}

/**
 * Get the latest value - or `undefined` - of a given topic from the Widgets bus.
 * Updates this value everytime it changes.
 */
export function useBusTopic<TBusPayload>(topic: string) {
  const [data, setData] = useState<TBusPayload | undefined>(undefined);

  useEffect(() => {
    const bus = getWidgetBus();
    const handle = bus?.subscribe<TBusPayload>(topic, (payload) => {
      setData(payload);
    });
    return () => {
      bus.unsubscribe(handle);
    };
  }, [topic]);

  return data;
}
